import { render } from "./MarketplacePaymentImportInfosModal.vue?vue&type=template&id=63cef3a3&scoped=true&ts=true&lang=pug"
import script from "./MarketplacePaymentImportInfosModal.vue?vue&type=script&lang=ts"
export * from "./MarketplacePaymentImportInfosModal.vue?vue&type=script&lang=ts"

import "./MarketplacePaymentImportInfosModal.vue?vue&type=style&index=0&id=63cef3a3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cef3a3"]])

export default __exports__